module.exports = __webpack_public_path__ + "img/turbo_on.36b34c81.png";